import { __decorate } from "tslib";
import { action, observable } from 'mobx';
const extReg = /(.*)\.([^.]*)$/;
export default class AttachmentFile {
    constructor(file) {
        this.load(file);
    }
    load(file) {
        Object.assign(this, file);
        this.uid = String(file.uid);
        const { name } = file;
        if (name) {
            const matches = name.match(extReg);
            if (matches && matches.length > 2) {
                this.ext = matches[2];
                this.filename = matches[1];
            }
            else {
                this.ext = '';
                this.filename = name;
            }
        }
    }
}
__decorate([
    observable
], AttachmentFile.prototype, "name", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "size", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "url", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "filename", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "ext", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "status", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "percent", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "error", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "errorMessage", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "invalid", void 0);
__decorate([
    action
], AttachmentFile.prototype, "load", null);
